import { Breakpoints, styled, ThemeDefinition } from '@volkswagen-onehub/components-core';

export const ManageDealerDetailContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;
  
  @media (min-width: ${Breakpoints.b1600}px) {
    gap: 32px;
  }	
`;

export const ManageDealerCTAContainer = styled.div`
  display: flex;
  width: 100%;
  justify-content: center;

  @media (min-width: 375px) {
    justify-content: end;
  }

  button {
    width: 100%;

    @media (min-width: 375px) {
      width: fit-content;
    }

    span {
      font-size: ${(theme: ThemeDefinition) =>
    theme?.size?.static200 || '16px'} !important;

      @media (min-width: ${Breakpoints.b1600}px) {
        font-size: ${(theme: ThemeDefinition) =>
    theme?.size?.static250 || '20px'} !important;
      }
    }
  }
`;
